import { TimeRangePickerProps } from 'antd'
import dayjs from 'dayjs'

export const rangePresets: TimeRangePickerProps['presets'] = [
  { label: 'Today', value: [dayjs(), dayjs()] },
  { label: 'Yesterday', value: [dayjs().add(-1, 'd'), dayjs().add(-1, 'd')] },
  { label: 'Last week', value: [dayjs().add(-7, 'd'), dayjs()] },
  { label: 'Last month', value: [dayjs().add(-31, 'd'), dayjs()] },
]
